import React from 'react'

const EmailInbox = () => {
  return (
    <div>
         <h1><center>Coming Soon...</center></h1>
    </div>
  )
}

export default EmailInbox;